import { Icon } from '@rsuite/icons';
import { useState, useEffect } from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Button, Stack } from 'rsuite';

type Prop = {
  onCancelClicked: () => void;
  onContinueClicked: () => void;
  cancelLabel: string;
  continueLabel: string;
  threshold: number | 0;
};

export default function BottomDocker({
  onCancelClicked,
  onContinueClicked,
  cancelLabel,
  continueLabel,
  threshold = 250,
}: Prop): JSX.Element | null {
  const [showDocker, setShowDocker] = useState(false);

  useEffect(() => {
    const handleScroll = (): any => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;

      if (scrollTop + windowHeight >= documentHeight - threshold) {
        setShowDocker(true);
      } else {
        setShowDocker(false);
      }
    };

    handleScroll(); // run on mount in case initial position qualifies
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  if (!showDocker) return null;

  return (
    <div className="tg-bottom-docker">
      <Stack spacing={16} justifyContent="flex-end" direction="row">
        <Stack.Item>
          <Button appearance="subtle" onClick={onCancelClicked}>
            {cancelLabel}
          </Button>
        </Stack.Item>
        <Stack.Item>
          <Button
            className="next-btn"
            appearance="primary"
            onClick={onContinueClicked}
          >
            {continueLabel}
            <Icon as={FaArrowRight} />
          </Button>
        </Stack.Item>
      </Stack>
    </div>
  );
}
